import Component from '../core/Component';

export default class ProgressLine extends Component
{
    constructor($element)
    {
        super($element);
        this.heightOfWindow = window.innerHeight;
        this.bodyHeight = window.document.getElementsByTagName("body")[0].offsetHeight;
        this.total = this.bodyHeight - this.heightOfWindow;
        this.handleScroll = ::this.scroll
    }

    prepare()
    {
        if(window.innerWidth > 768){
            window.addEventListener('scroll', this.handleScroll)
        }
        
    }

    scroll(event){
        let scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
        let percentage = parseInt((scrollTop / this.total) * 100) + '%';
        this.element.style.height = percentage;
    }

    destroy(){
        window.removeEventListener('scroll', this.handleScroll)
    }

}




// WEBPACK FOOTER //
// ./components/ProgressLine.js